import React from 'react';
type propT = {
  strokeColor?: string;
  size?: number;
};
import Dashboard from '@uber/base-icons/dashboard';
function Icon({
  strokeColor,
  size = 16
}: propT) {
  return <Dashboard size={size} stroke={strokeColor} />;
}
export default Icon;